import Vue from 'vue';
import inView from 'vueinview';

let bOffset = window.innerHeight / 4;

inView.threshold(1);
inView.offset({
  top: bOffset,
  bottom: bOffset,
});

Vue.use(inView);